import {useContext, useEffect, useState} from 'react';
import HeadingAndExpandableBody from '../UI/HeadingAndExpandableBody';
import {Context} from '../../context';
import {dollarAmount, getDateString} from '../../helperFunctions';

const getLast4CardNumbers = (uuid, account) => {
  const card = account?.transitAccounts[0].transitCards?.find(
    c => c.uuid === uuid
  );
  return String(card?.cardNumber || '').slice(-4);
};

function FareCapping(props) {
  const {localeText, account} = useContext(Context);

  const [fareCaps, setFareCaps] = useState(account?.fareCaps || []);

  useEffect(() => {
    setFareCaps(account?.fareCaps || []);
  }, [account?.fareCaps]);

  const calculatePercentage = (used, cap) => {
    if (!cap || cap === 0) return 0;
    return Math.min((used / cap) * 100, 100);
  };

  return (
    <HeadingAndExpandableBody
      headingAndExpandableBodyId='fare-capping'
      heading={localeText(
        'rw_header_fare_capping_progress',
        'Fare Capping Progress'
      )}
      expanded={props.expanded}
    >
      {fareCaps.length > 0 ? (
        fareCaps.map(cap => {
          const capAmount = cap.cap_amount / 100;
          const progress = cap.progress / 100;
          const remaining = Math.max(capAmount - progress, 0);
          const percentage = calculatePercentage(progress, capAmount);

          return (
            <div key={cap.card_uuid} className='mb-8'>
              <h3 className='font-bold text-lg'>
                {cap.cardName}{' '}
                <span className='font-normal text-gray-600'>
                  {getLast4CardNumbers(cap.card_uuid, account)}
                </span>
              </h3>
              <div key={cap.card_uuid} className='mb-6'>
                <div className='mb-2 text-lg'>{cap.pot_name}</div>
                {cap.last_reset && (
                  <div className='mb-2'>
                    {localeText('rw_title_last_reset', 'Last Reset')}:{' '}
                    {getDateString(cap.last_reset, ['date'])}
                  </div>
                )}
                <div className='w-full bg-gray-300 rounded-full h-6 mb-2 relative overflow-hidden'>
                  <div
                    className='bg-blue-600 h-6 rounded-full flex items-center justify-center text-white text-sm font-semibold'
                    style={{width: `${percentage}%`}}
                  >
                    {percentage >= 20 && `${Math.round(percentage)}%`}
                  </div>
                  {percentage < 20 && percentage > 0 && (
                    <div className='absolute inset-0 flex items-center justify-center text-sm font-semibold'>
                      {Math.round(percentage)}%
                    </div>
                  )}
                </div>
                <div className='flex justify-between'>
                  <span>
                    {dollarAmount(progress * 100)}{' '}
                    {localeText('rw_title_used', 'Used')}
                  </span>
                  <span>
                    {dollarAmount(remaining * 100)}{' '}
                    {localeText('rw_title_remaining', 'Remaining')} /{' '}
                    {dollarAmount(capAmount * 100)}{' '}
                    {localeText('rw_title_cap', 'Cap')}
                  </span>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <p className='text-center text-gray-600'>
          {localeText(
            'rw_msg_no_fare_capping_data',
            'No fare capping data available'
          )}
        </p>
      )}
    </HeadingAndExpandableBody>
  );
}

export default FareCapping;
